import React, { useState, useEffect } from 'react';
import ProductsPage from './ProductsPage';
import { products } from '../Data/products';

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [typedContent, setTypedContent] = useState(['', '', '']);
  const [typingIndex, setTypingIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [Products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 1000));
        setProducts(products);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, []);
  const content = [
    "At <strong>Dr BhuPat Pharma</strong>, we are dedicated to revolutionizing women's healthcare by delivering high-quality pharmaceutical solutions. With a strong focus on gynecological care, we strive to empower women by providing innovative, effective, and safe healthcare products.",
    "Our commitment extends beyond medicine—we foster a culture of innovation, ethical responsibility, and excellence, ensuring that every product we create meets the highest standards of safety and efficacy. With a rapidly growing presence, we are expanding our footprint to make quality healthcare accessible to more communities.",
    "At <strong>Dr BhuPat Pharma</strong>, we believe in <em>healing, empowering, and transforming lives</em> through science and innovation."
  ];

  const values = [
    {
      icon: "fas fa-bullseye",
      title: "Our Vision",
      description: "At Dr BhuPat Pharma Private Limited, we are committed to delivering high-quality products that meet the evolving needs of women. Fostering a culture of innovation and excellence."
    },
    {
      icon: "fas fa-award",
      title: "Our Mission",
      description: "To be a trusted partner in women's healthcare, delivering high-quality gynecare products that address unique needs, promote wellness, and foster a culture of self-care and empowerment."
    },
    {
      icon: "fas fa-heart",
      title: "Our Values",
      description: "Taking ownership for our actions, and being accountable for our impact on patients, the environment, and society. Operating with transparency, honesty, and ethics in all our dealings."
    }
  ];

  const ethics = [
    {
      image: "/assets/innovation.png",
      title: "Innovation-The world move on innovation",
      description: "- We at BhuPat Pharma Encouraging a culture of creativity and innovation and embracing new technologies and ideas to improve patient outcomes."
    },
    {
      image: "assets/Integrity.png",
      title: "Integrity-Flawless execution",
      description: "- Operating with transparency and honesty in all our interactions and upholding the highest ethical standards in our business practices."
    },
    {
      image: "assets/Responsibility.png",
      title: "Responsibility-We own our actions",
      description: "- Taking ownership of our actions and their impact on society and the environment and prioritizing safety, sustainability, and social responsibility in our operations."
    },
    {
      image: "/assets/Agility.png",
      title: "Agility – we move with speed in dynamic environment",
      description: "- Embracing change and adapting to new challenges and opportunities. We at BhuPat Pharma responsive to the evolving needs of patients and customers."
    },
    {
      image: "/assets/Respect.png",
      title: "Respect – we run admiration throughout",
      description: "- Valuing diversity and promoting inclusivity in our workplace and communities. We at BhuPat Pharma respect the opinions and perspectives of others."
    },
    {
      image: "/assets/Community.png",
      title: "Community – We committed to community we live",
      description: "- Building strong relationships with the communities we serve. We BhuPat Pharma always keep supporting local initiatives and charitable causes."
    }
  ];

  const stats = [
    { value: "24+", label: "Team Members" },
    { value: "5+", label: "Medical Sectors Covered" },
    { value: "1000+", label: "Patients Served" }
  ];
  useEffect(() => {
    if (Products.length > 0 && Products[0].image) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % Products.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [Products]);

  useEffect(() => {
    const typingTimer = setTimeout(() => {
      if (typingIndex < content.length) {
        if (charIndex < content[typingIndex].length) {
          setTypedContent(prev => {
            const newContent = [...prev];
            newContent[typingIndex] = content[typingIndex].substring(0, charIndex + 1);
            return newContent;
          });
          setCharIndex(charIndex + 1);
        } else {
          setTypingIndex(typingIndex + 1);
          setCharIndex(0);
        }
      }
    }, 20);

    return () => clearTimeout(typingTimer);
  }, [typingIndex, charIndex, content]);



  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <div className="company-name">
            <span className="text-black">Dr. </span>
            <span className="text-green-500">Bhu</span>
            <span className="text-blue-500">Pat</span>
            <span className="text-black"> Pharma Pvt Ltd.</span>
          </div>
          <h2 className="hero-subtitle">Best Quality Products</h2>
          <div className="divider"></div>
          <p className="hero-description">
            Dr. BhuPat Pharma Pvt Ltd. is providing best quality, innovative and affordable products according to consumer needs, scientifically proven quality and efficacy healthcare solutions.
          </p>
        </div>
        <div className="hero-image-container">
          {isLoading ? (
            <div className="loading">Loading products...</div>
          ) : (
            Products.length > 0 && (
              <div className="rotating-image-container">
                <img
                  key={Products[currentImageIndex].id}
                  src={Products[currentImageIndex].image}
                  alt={`Product ${currentImageIndex + 1}`}
                  className="product-image1 active"
                />
              </div>
            )
          )}
        </div>
      </div>

      {/* Who We Are Section */}
      <section className="about-section">
        <header className="section-header">
          <h4>Who We Are <hr /></h4>
        </header>
        <div className="about-content">
          <h2>Dr BhuPat Pharma</h2>
          {typedContent.map((paragraph, index) => (
            <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }}></p>
          ))}
        </div>
      </section>
      <div className='Values-container'>
        {/* Vision/Mission/Values Section */}
        <section className="values-section">
          <div className="values-containerm">
            <div className="values-gridm">
              {values.map((value, index) => (
                <div key={index} className="value-cardm">
                  <div className="card-contentm">
                    <div className="card-headerm">
                      <i className={value.icon}></i>
                      <h2>{value.title}</h2>
                    </div>
                    <p>{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <ProductsPage />

      {/* Ethics and Values Section */}
      <section className="ethics-section">
        <div className="ethics-container">
          <h2 className="section-header">Our Ethics and Values</h2>
          <div className="ethics-grid">
            {ethics.map((ethic, index) => (
              <div key={index} className="ethics-card">
                <img src={ethic.image} alt={ethic.title} />
                <h4>{ethic.title}</h4>
                <p>{ethic.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Life at Company Section */}
      <section className="life-at-companym">
        <div className="company-title">
          <span className="text-black">Life at </span>
          <span className="text-black">Dr. </span>
          <span className="text-green-500">Bhu</span>
          <span className="text-blue-500">Pat</span>
          <span className="text-black"> Pharma Pvt Ltd.</span>
        </div>
      </section>

      <section className="company-video">
        <video autoPlay loop playsInline muted>
          <source src="/assets/phrama.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>

      {/* Experience Section */}
      <section className="experience-section">
        <div className="experience-image">
          <img
            src='/assets/member2.jpg'
            alt="Team member"
            loading="lazy"
          />
        </div>
        <div className="experience-content">
          <h2 className="experience-title">We Provide You<br />The Best Experience</h2>
          <p>
            At Dr. BhuPat Pharma Pvt. Ltd., we are committed to providing you with the best experience through our exceptional healthcare solutions and services. Our dedication to quality, innovation, and customer satisfaction makes us your trusted partner in women's healthcare. We prioritize delivering high-quality gynecare products that cater to the evolving needs of women. Our products are formulated with advanced technology, natural ingredients, and a deep understanding of feminine health. Each product undergoes rigorous testing to ensure safety, efficacy, and reliability. Innovation drives us forward, and we embrace cutting-edge technologies and creative approaches to develop solutions that improve women's health outcomes. Our constant pursuit of innovation ensures that we provide products that align with modern healthcare needs. Understanding that every customer is unique, we adopt a personalized approach to healthcare solutions. By actively seeking feedback and understanding your needs, we continuously enhance our products and services.
          </p>
          <div className="experience-btn">
            <button className="btn">Learn More</button>
          </div>
        </div>
        <div className="experience-stats">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <h4>{stat.value}</h4>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section" id="contact">
        <h2 className="newsletter-title">Subscribe<br />Drxperientia –Dr BhuPat Pharma Newsletter</h2>
        <form className="newsletter-form">
          <input type="email" placeholder="Enter your email" />
          <button type="submit" className="subscribe-btn">Subscribe</button>
        </form>
      </section>
    </div>
  );
};

export default Home;